import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
 } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatPaginator } from '@angular/material/paginator';
import { Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { User } from 'src/app/@core/models/infrastructure/User.model';
import { LdapService } from 'src/app/@core/services/ldap/ldap.service';
import { InfrastructureService } from 'src/app/@core/services/infrastructure/infrastructure.service';
import {MatTableDataSource} from '@angular/material/table';
import { Infrastructure } from 'src/app/@core/models/infrastructure/Infrastructure.model';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service';

@Component({
  selector: 'app-global-user-admin-table-step',
  templateUrl: './global-user-admin-table-step.component.html',
  styleUrls: ['./global-user-admin-table-step.component.scss']
})
export class GlobalTableUsersStepComponent implements OnInit {
  MIN_CHARS_SUGGEST = 3;
  selectedNuumas: User[] = [];
  filteredNuumas: Observable<string[]>;
  displayedColumns: string[] = ['name', 'action'];
  dataSource: MatTableDataSource<User>;
  newRole: string = 'admin'
  repUser: boolean;
  isSelect: boolean;
  nuumaSelect: string;
  adminMustBeSelected: boolean;
  atLeastOneAdmin: boolean;
  adminUserEmpty: boolean;
  userToDeleteSameAsLogged: boolean;
  userLogged: string = '';
    
  public loading = false;
  public notResults = false;

  adminCtrl = new FormControl();

  @Input() infrastructure: Infrastructure;
  @ViewChild('adminInput') adminInput: ElementRef<HTMLInputElement>;
  @ViewChild('autoNuumas') matAutocomplete: MatAutocomplete;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    private readonly ldapService: LdapService, 
    private infraService: InfrastructureService,
    public darkModeService: DarkModeService) {
      this.adminCtrl.valueChanges.pipe(
        debounceTime(300)
      ).subscribe((x) => {
        let sbs: Subscription;
        if (x && x.length >= this.MIN_CHARS_SUGGEST) {
          this.loading = true;
          this.notResults = false;
          this.filteredNuumas = this.ldapService.search(x);
          sbs = this.filteredNuumas.subscribe((rsp: string[]) => {
            this.loading = false;
            if (rsp && rsp.length === 0) {
              this.notResults = true;
            }
            sbs.unsubscribe();
          });
        } else {
          this.notResults = false;
          this.loading = false;
          this.filteredNuumas = null;
        }
      });
    }

  ngOnInit(): void {
    this.observerUserInput();

    if (this.infrastructure && this.infrastructure.admins) {
      this.infrastructure.admins.forEach((user) => {
        this.selectedNuumas.push(user);
      });
    }

    this.dataSource = new MatTableDataSource<User>(this.selectedNuumas.filter(nuuma => nuuma.action !== "delete"))
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }

  addNew(roleSelect: string){
    this.newRole = roleSelect;
    this.cleanWarmMessages();

    if (this.adminCtrl.value === null || this.adminCtrl.value.trim() === "") {
      this.adminUserEmpty = true;
    } else {
      const user: User = {name: this.adminCtrl.value, mail: '', role: this.newRole, action: 'add' }; 
      if (!this.isSelect) {
        this.adminMustBeSelected  = true;
        this.adminCtrl.setValue(null);
      } else {
        // Si el usuario ya está marcado para eliminar y luego lo añadimos.
        let adminExistInGlobalAdmin = false;
        this.selectedNuumas.forEach(u => {
          if (u.name === user.name && u.action === 'delete') {
            u.action = '';
            adminExistInGlobalAdmin = true;
          }
        });
        if (!adminExistInGlobalAdmin){
          this.isDuplicatedUsersNuuma(this.adminCtrl.value);
          if (this.infrastructure.isDuplicatedAdmin) {
            this.repUser = true;
            this.adminCtrl.setValue(null);
          } else {
            this.selectedNuumas.push(user);
          }  
        }
        this.dataSource = new MatTableDataSource(this.selectedNuumas.filter(nuuma => nuuma.action !== "delete"));
        this.dataSource.paginator = this.paginator;
        this.dataSource.paginator.lastPage();
        this.valueToInfra();
        this.adminCtrl.setValue(null);
      }
    }

    this.isSelect = false;
  }

  cleanSuggestions() {
    this.filteredNuumas = new Observable<string[]>();
  }

  cleanWarmMessages() {
    this.repUser = false;
    this.atLeastOneAdmin = false;
    this.adminUserEmpty = false;
    this.userToDeleteSameAsLogged = false;
    this.adminMustBeSelected  = false;
  }

  remove(nuuma: User): void {
    this.cleanWarmMessages();

    if (this.selectedNuumas.filter(nuuma => nuuma.action !== "delete").length <= 1) {
      this.atLeastOneAdmin = true;
    } else {
      this.infraService.getUserLogged().subscribe((user) => {
        this.userLogged = user.name;

        if (this.userLogged === nuuma.name) {
          this.userToDeleteSameAsLogged = true;
        } else {
          const index = this.selectedNuumas.indexOf(nuuma);
          if (index >= 0) {
            if (nuuma.action === 'add'){
              this.selectedNuumas.splice(index, 1);
            }
            nuuma.action = 'delete';
            this.dataSource = new MatTableDataSource(this.selectedNuumas.filter(nuuma => nuuma.action !== "delete"));
            this.valueToInfra();
            this.adminCtrl.setValue(null);
            this.dataSource.paginator = this.paginator;
          }
        }
      });
    }
  }

  isDuplicatedUsersNuuma(id: String) {
    this.infrastructure.isDuplicatedAdmin = false;
    
    this.selectedNuumas.forEach((user) => {
      if (!this.infrastructure.isDuplicatedAdmin){
      const duplicateUsersArray = this.selectedNuumas.filter(nuuma => user.name === id);
      this.infrastructure.isDuplicatedAdmin = duplicateUsersArray.length > 0 ? true : false;
      }
    });
  }

  valueToInfra() {
    this.infrastructure.admins = [];

    this.selectedNuumas.forEach((element) => {
      const u = new User();
      u.name = element.name;
      u.mail = element.mail;
      u.action = element.action; 
      this.infrastructure.admins.push(u);
    });
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.nuumaSelect= event.option.value;
    this.isSelect = true;
    this.addNew('admin');
  }

  observerUserInput() {
    this.adminCtrl.valueChanges.subscribe(rest => { 
      if ( rest === '' || rest !== this.nuumaSelect ){
        this.isSelect = false;
      }  
    });
  }
}
